var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.el(_vm.href),
    {
      tag: "component",
      attrs: { to: _vm.href, href: _vm.href, target: _vm.target },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }